/**
 * 判断是否数字
 * @return {Boolean} 是否数字
 */
import isType from './is-type';
var isNumber = function (value) {
    return isType(value, 'Number');
};
export default isNumber;
//# sourceMappingURL=is-number.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/is-number.js
// module id = 38
// module chunks = 3